export default __webpack_public_path__ + "static/media/b2.26ac060b.jpg";